import { memo } from "react";

const SendEmail = () => (
  <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.9166 7V2.9375H6.49992H1.08325V7V11.0625H6.49992"
      stroke="currentColor"
      strokeWidth="1.08333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.9167 9.70825H8.125"
      stroke="currentColor"
      strokeWidth="1.08333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5625 8.35425L11.9167 9.70841L10.5625 11.0626"
      stroke="currentColor"
      strokeWidth="1.08333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.08325 2.9375L6.49992 7L11.9166 2.9375"
      stroke="currentColor"
      strokeWidth="1.08333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default memo(SendEmail);
